import React, { useRef, useImperativeHandle } from "react";
import {
  Typography,
  Box,
  Grid,
  Divider,
  Chip,
  Avatar,
  Stack,
} from "@mui/material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ContactInformation from "./ContactInformation";
import Declaration from "./Declaration";
import Consignment from "./Consignment";
import moment from "moment";

const Invoice = React.forwardRef(({ tripDetails, isPaymentReceipt }, ref) => {
  console.log("pdf");
  const pdfRef = useRef(null);
  const invoiceNumberSuffix =
    tripDetails?.tripId?.split("_")?.[1] || tripDetails?.tripId || "-";
  const vehicleNumber =
    tripDetails?.truck?.VehicleNumber ||
    tripDetails?.vehicleDetails?.vehicleNumber ||
    "-";

  const generatePDF = () => {
    if (!pdfRef.current) {
      console.log("here");
      return;
    }

    try {
      html2canvas(pdfRef.current, {
        scale: 2,
        useCORS: false,
        allowTaint: true,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
        pdf.link(58, 235, 65, 5, {
          url: "https://loadeazy.com/terms&conditions",
        });
        pdf.link(147, 255, 65, 5, {
          url: "mailto:juggernautventures23@gmail.com",
        });
        let filename = isPaymentReceipt
          ? `${tripDetails.tripId}_paymentReceipt.pdf`
          : `${tripDetails.tripId}_invoice.pdf`;
        pdf.save(filename);
      });
    } catch (err) {
      console.log(err);
      console.log("error-create-pdf");
    }
  };

  useImperativeHandle(ref, () => ({
    generatePDF,
  }));

  const FareItem = ({ label, amount, bold = false }) => (
    <Grid container my={2}>
      <Grid item xs={6}>
        <Typography
          variant="body1"
          component="span"
          sx={{ color: "#4a4a4a", fontWeight: bold ? "bold" : "normal" }}
        >
          {label}
        </Typography>
      </Grid>
      <Grid item xs={6} sx={{ textAlign: "right" }}>
        <Typography
          variant="body1"
          component="span"
          sx={{ color: "#4a4a4a", fontWeight: bold ? "bold" : "normal" }}
        >
          ₹{amount}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <Box
      ref={pdfRef}
      id="pdf-content"
      sx={{
        position: "absolute",
        top: -9999,
        left: -9999,
        width: "210mm",
        px: 4,
        border: "1px solid #000",
        backgroundColor: "#fff",
        fontSize: "8px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "297mm",
      }}
    >
      <Box>
        <Typography
          variant="h6"
          component="h2"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", fontSize: "24px" }}
        >
          {isPaymentReceipt ? "PAYMENT RECEIPT" : "INVOICE / CONSIGNMENT NOTE"}
        </Typography>
        <Grid container spacing={1}>
          <Box sx={{ mx: 1 }}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={6}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Stack alignItems="center" spacing={1}>
                    {/* Logo block */}
                    <Box sx={{ position: "relative", width: 80, height: 80 }}>
                      {/* Vertical L */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          width: 20,
                          height: "100%",
                          bgcolor: "grey.900",
                        }}
                      />
                      {/* Bottom L */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: 0,
                          bottom: 0,
                          width: "100%",
                          height: 20,
                          bgcolor: "grey.900",
                        }}
                      />
                      {/* Green E top */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: 24,
                          top: 0,
                          height: 15,
                          width: "68%",
                          bgcolor: "green",
                        }}
                      />
                      {/* Green E middle */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: 24,
                          top: "26%",
                          height: 15,
                          width: "55%",
                          bgcolor: "green",
                        }}
                      />
                      {/* Green E bottom */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: 24,
                          bottom: 24,
                          height: 15,
                          width: "68%",
                          bgcolor: "green",
                        }}
                      />
                    </Box>

                    {/* Text below */}
                    <Typography variant="h4">
                      <Box component="span" fontWeight="bold" color="grey.900">
                        Load
                      </Box>
                      <Box component="span" fontWeight="bold" color="green">
                        Eazy
                      </Box>
                    </Typography>
                  </Stack>
                  {/* <img
                    src="/assets/icons/LZ-logo-paymnet-page.png"
                    alt="logo"
                    style={{
                      height: "200px",
                      display: "block",
                      margin: "auto",
                    }}
                  /> */}
                </Box>
                <Consignment customerDetails={tripDetails?.customerDetails} />
                <Box
                  sx={{
                    mt: 1,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#F0F0F0",
                  }}
                >
                  <Typography variant="body1" sx={{ color: "#4a4a4a", mb: 1 }}>
                    MATERIAL NAME
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#4a4a4a",
                      fontWeight: "bold",
                      fontSize: "10px",
                    }}
                  >
                    {tripDetails?.enquiryDetails?.material?.name}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    mt: 1,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#F0F0F0",
                  }}
                >
                  <Typography variant="body1" sx={{ color: "#4a4a4a", mb: 1 }}>
                    MATERIAL WEIGHT
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#4a4a4a",
                      fontWeight: "bold",
                      fontSize: "10px",
                    }}
                  >
                    {tripDetails?.enquiryDetails?.weight} KG
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ textAlign: "right", fontSize: "12px" }}>
                  <Typography
                    sx={{ fontWeight: "bold", fontSize: "12px" }}
                    component="span"
                  >
                    {isPaymentReceipt ? "RECEIPT NO:" : "INVOICE NUMBER:"}
                  </Typography>
                  <Typography component="span" sx={{ fontSize: "12px" }}>
                    {`LEIV${invoiceNumberSuffix}`}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                  <Typography
                    sx={{ fontWeight: "bold", fontSize: "12px" }}
                    component="span"
                  >
                    DATE:
                  </Typography>
                  <Typography component="span" sx={{ fontSize: "12px" }}>
                    {moment(tripDetails?.tripCompletedTimeStamp).format(
                      "DD/MM/YYYY"
                    )}
                  </Typography>
                </Box>
                {isPaymentReceipt ? (
                  <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: "#F0F0F0",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="h4"
                      component="h3"
                      sx={{
                        color: "#4a4a4a",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      PAYMENT STATUS
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        fontSize: "14px",
                        color: "#4a4a4a",
                        fontWeight: "bold",
                      }}
                    >
                      {tripDetails.customerPaymentStatus}
                    </Typography>
                  </Box>
                ) : null}

                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#F0F0F0",
                  }}
                >
                  {!isPaymentReceipt ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="h4"
                            component="span"
                            sx={{
                              color: "#4a4a4a",
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Total Amount
                          </Typography>
                          <Typography
                            variant="body1"
                            component="span"
                            sx={{
                              color: "#4a4a4a",
                              fontWeight: "bold",
                              ml: 1,
                              mt: 1,
                            }}
                          >
                            (Rounded)
                          </Typography>
                        </Box>

                        <Typography
                          variant="body1"
                          component="span"
                          sx={{
                            color: "#4a4a4a",
                            fontWeight: "bold",
                            ml: 1,
                            mt: 1,
                          }}
                        >
                          ₹{tripDetails?.customerAmounts?.finalAmount}
                        </Typography>
                      </Box>
                      <Divider sx={{ borderColor: "#4a4a4a", my: 1 }} />
                      <FareItem
                        label="Trip Fare"
                        amount={tripDetails?.customerAmounts?.finalAmount}
                      />
                      <FareItem label="Discount" amount="0.00" />
                      <Divider sx={{ borderColor: "#4a4a4a", my: 1 }} />
                      <FareItem
                        label="Sub Total"
                        amount={tripDetails?.customerAmounts?.finalAmount}
                        bold
                      />
                      <FareItem label="CGST" amount="0.00" />
                      <FareItem label="SGST" amount="0.00" />
                      <Divider sx={{ borderColor: "#4a4a4a", my: 1 }} />
                      <FareItem
                        label="Net Fare"
                        amount={tripDetails?.customerAmounts?.finalAmount}
                        bold
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: 1,
                        }}
                      >
                        <Chip
                          label="Happy to complete your trip at promised fare."
                          variant="outlined"
                          sx={{
                            width: "100%",
                            textAlign: "center",
                            borderRadius: "25px",
                            fontWeight: "bold",
                            background: "#E0E0E0",
                            fontSize: "12px",
                          }}
                        />
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant="h4"
                          component="h1"
                          sx={{
                            color: "#4a4a4a",
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          Receipt
                        </Typography>
                        <Divider sx={{ borderColor: "#4a4a4a", my: 1 }} />
                        <FareItem
                          label="Advance payment"
                          amount={tripDetails?.customerAmounts?.amountReceived}
                        />
                        <FareItem
                          label="Balance Payable"
                          amount={
                            tripDetails?.customerAmounts?.balanceReceivable
                          }
                        />
                        <Divider sx={{ borderColor: "#4a4a4a", my: 1 }} />
                        <FareItem
                          label="Total Amount"
                          amount={tripDetails?.customerAmounts?.finalAmount}
                          bold
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 1,
                          }}
                        >
                          <Chip
                            label="Happy to complete your trip at promised fare."
                            variant="outlined"
                            sx={{
                              width: "100%",
                              textAlign: "center",
                              borderRadius: "25px",
                              fontWeight: "bold",
                              background: "#E0E0E0",
                              fontSize: "12px",
                            }}
                          />
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>

                <Box>
                  <Box
                    sx={{
                      borderRadius: 2,
                    }}
                  >
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            mt: 1,
                            p: 2,
                            borderRadius: 2,
                            backgroundColor: "#F0F0F0",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                gap: "4px",
                              }}
                            >
                              {/* <img
                                src="/assets/icons/vehicle.png"
                                width={20}
                                alt="comingsoon"
                              /> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="20px"
                                viewBox="0 -960 960 960"
                                width="20px"
                                fill="#1f1f1f"
                              >
                                <path d="M480-480Zm80 240q100 0 170-70t70-170q0-101-73.5-170.5T550-720q-48 0-93 11t-87 33l100 40q41 17 65.5 52.5T560-504q0 60-41.5 102T418-360H162q-2 24-2 54.5v65.5h400ZM176-440h240q27 0 45.5-18.5T480-504q0-19-10.5-34.5T440-562l-148-60q-42 37-71.5 84T176-440Zm384 280H160q-33 0-56.5-23.5T80-240v-90q0-98 37-183.5t100.5-149Q281-726 367-763t183-37q68 0 128 25t105 68.5Q828-663 854-605t26 125q0 66-25 124.5t-68.5 102Q743-210 684.5-185T560-160Z" />
                              </svg>

                              <Typography
                                variant="h4"
                                component="h3"
                                sx={{
                                  color: "#4a4a4a",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                Vehicle Number
                              </Typography>
                            </Box>{" "}
                            <Typography
                              variant="h4"
                              component="h3"
                              sx={{
                                color: "#4a4a4a",
                                fontWeight: "bold",
                                fontSize: "14px",
                                marginLeft: "24px",
                              }}
                            >
                              {vehicleNumber}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {/* <img
                                src="/assets/icons/driver.png"
                                width={20}
                                alt="comingsoon"
                              /> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="16"
                                viewBox="0 0 24 24"
                                width="16"
                                fill="#000"
                              >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
                              </svg>

                              <Typography
                                variant="h4"
                                component="h3"
                                sx={{
                                  color: "#4a4a4a",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                Driver Name
                              </Typography>
                            </Box>{" "}
                            <Typography
                              variant="h4"
                              component="h3"
                              sx={{
                                color: "#4a4a4a",
                                fontWeight: "bold",
                                fontSize: "14px",
                                marginLeft: "24px",
                              }}
                            >
                              {tripDetails?.driver?.driverName ?? "    -"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          m: 2,
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={5.5}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "4px",
                              }}
                            >
                              <Typography
                                variant="body1"
                                sx={{ fontSize: "10px", fontWeight: "bold" }}
                              >
                                Pickup Person Details
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{ fontSize: "10px" }}
                              >
                                Name:{" "}
                                {tripDetails?.pickupContactPerson?.name ??
                                  "    -"}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "10px" }}
                              >
                                Contact Number:{" "}
                                {tripDetails?.pickupContactPerson
                                  ?.phoneNumber ?? "    -"}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "10px" }}
                              >
                                Address:{" "}
                                {tripDetails?.enquiryDetails?.pickup?.location
                                  ?.address ?? "    -"}
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid
                            item
                            xs="auto"
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Box
                              sx={{
                                width: "1px",
                                backgroundColor: "#E0E0E0",
                                height: "100%",
                              }}
                            />
                          </Grid>

                          <Grid item xs={5.5}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "4px",
                              }}
                            >
                              <Typography
                                variant="body1"
                                sx={{ fontSize: "10px", fontWeight: "bold" }}
                              >
                                Drop-off Person Details
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{ fontSize: "10px" }}
                              >
                                Name:{" "}
                                {tripDetails?.dropOffContactPerson?.name ??
                                  "    -"}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "10px" }}
                              >
                                Contact Number:{" "}
                                {tripDetails?.dropOffContactPerson
                                  ?.phoneNumber ?? "    -"}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "10px" }}
                              >
                                Address:{" "}
                                {tripDetails?.enquiryDetails?.dropoff?.location
                                  ?.address ?? "    -"}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ px: 2 }}>
            <Grid container spacing={1}>
              <Declaration />
            </Grid>
          </Box>
        </Grid>
      </Box>
      <ContactInformation />
    </Box>
  );
});

export default Invoice;
